






























































































































































































































import { Vue, Component, Watch, Ref } from "vue-property-decorator";

import router from "@/router/router";

import DeviceItem from "./DeviceItem.vue";
import { ToolbarContentModule } from "@/store/modules/ToolbarContent";
import { DevicesModule } from "@/store/modules/DevicesModule";
import { getUpdatedCategoryAndTemplateIds, getTemplateIdFromSerialNumber, isClientPanel, isIresTemplate } from "@/data/models/DeviceSettingsManager";
import { getDefaultBranchFilterOfUser, getReactiveActiveUser } from "@/data/repository/UserRepository";
import ClientPanel from "@/data/models/ClientPanel";
import { GenericDeviceFilter, getGenericFilterName, matchesGenericDeviceFilter } from "@/data/models/DeviceFilter";
import { DeviceCategoryTemplate } from "@/data/models/DeviceCategoryTemplate";
import { getNumber, setNumber } from "@/utils/SecureLocalStorage";
import { DeviceOverview } from "@/data/models/DeviceOverview";
import { getBranchName } from "@/data/models/Branch";
import { findBranch, hasClientEnabledStrictBranchFilters, shouldHideSerialNumber } from "@/data/repository/ClientRepository";
import { BranchFilter } from "@/data/models/BranchFilter";
import BranchFilterSelectorComponent from "../common/BranchFilterSelector.vue";
import InfiniteLoading, { StateChanger } from "vue-infinite-loading";
import MenuIconWithSelectionListComponent from "../common/FilterMenu.vue";
import SearchForDeviceComponent from "../devices/SearchForDevice.vue";
import DeviceDetailsDialog from "./DeviceDetailsDialog.vue";
import { observeDeviceOverviews } from "@/data/repository/AllDevicesRepository";
import { getClientPanelsRef, observeClientPanels, updateClientPanelsBySerialNumber } from "@/data/repository/ClientPanelRepository";
import { filterRetainedDevices, sortDevices } from "@/utils/DeviceManagementUtils";
import { COLOR_DISABLED, COLOR_HEADER_BUTTON, COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";
import { getClientDevicesRef, updateDevicesById } from "@/data/repository/GenericDeviceRepository";
import { DELETION_SEPARATOR, calculateBackgroundStyle, getReleasedQrCodes, getUpdatedIdsAfterDeletion, setLastVisitedItem, StorageKeyLastVisitedItemLevel } from "@/utils/Utils";
import MultiDevicesDetailsDialog from "./MultiDevicesDetailsDialog.vue";
import ConfirmationDialogComponent from "../common/ConfirmationDialog.vue";
import { editAllDevicesAccess } from "@/permissions/UserPermissions";
import { defineCategoriesAndTemplatesClientAccess } from "@/permissions/ClientPermissions";
import { DeviceCategoriesAndTemplatesModule } from "@/store/modules/DeviceCategoriesAndTemplatesModule";
import { getAllVehiclesOfClient, removeDevicesFromVehicleMapBatch } from "@/data/repository/VehicleRepository";
import Vehicle from "@/data/models/Vehicle";
import ToolbarOverflowItemComponent from "@/components/common/ToolbarOverflowItem.vue";
import { getStoredBranchFilterId, setStoredBranchFilterId, removeStoredBranchFilterId } from "@/utils/BranchFilterStorage";

@Component({
  components: {
    "toolbar-overflow-item": ToolbarOverflowItemComponent,
    "branch-filter-selector": BranchFilterSelectorComponent,
    "device-details-dialog": DeviceDetailsDialog,
    "device-item": DeviceItem,
    "infinite-loading": InfiniteLoading,
    "menu-icon": MenuIconWithSelectionListComponent,
    "search-for-device": SearchForDeviceComponent,
    "confirmation-dialog": ConfirmationDialogComponent,
    "multi-devices-details-dialog": MultiDevicesDetailsDialog,
  },
})

export default class DevicesComponent extends Vue {
  @Ref("createDeviceDialog")
  createDeviceDialog!: DeviceDetailsDialog;

  @Ref("confirmDialog")
  confirmationDialog!: ConfirmationDialogComponent;

  @Ref("multiDevicesDetailsDialog")
  deviceDetailsDialog!: MultiDevicesDetailsDialog;

  allDevices: ClientPanel[] = [];
  allFilters = [
    GenericDeviceFilter.ALL_DEVICES,
    GenericDeviceFilter.IN_USAGE,
    GenericDeviceFilter.AVAILABLE,
    GenericDeviceFilter.NOT_AVAILABLE,
  ];
  categoryId = "";
  componentActive = false;
  forceUpdateBackgroundColor = false;
  hasNoDevices = true;
  infiniteId = new Date();
  isLoading = true;
  pageSize = 20;
  refreshTimer!: NodeJS.Timeout;
  refreshTrigger = 0;
  selectedCategory: DeviceCategoryTemplate[] = [];
  searchQuery: string | null = null;
  searchQueryKey = "SearchQuery";
  searchTimeout: NodeJS.Timeout | null = null;
  selectedBranchFilter = getDefaultBranchFilterOfUser();
  selectedCategoryName = "";
  selectedDeviceFilter = GenericDeviceFilter.ALL_DEVICES;
  showNoDevicesMessage = false;
  sliceLength = this.pageSize;
  storageKeyAllDevicesFilter = "storageKeyAllDevicesFilter";
  storageKeyBranchFilter = "AllDevicesBranchFilter";
  storageKeySliceLength = "devicesStorageKeySliceLength";
  subscriptions: Array<() => void> = [];
  timer: NodeJS.Timeout | null = null;
  templateId = "";
  windowWidth = 0;

  noOfFilteredDevices = 0;

  retrievedClientPanels: ClientPanel[] = [];
  retrieveDeviceOverviews: DeviceOverview[] = [];
  vehicles: Vehicle[] = [];

  isSelectionMode = false;
  isDeletingDevices = false;

  selectedClientPanels: ClientPanel[] = [];
  selectedDeviceOverviews: DeviceOverview[] = [];

  showingSuccessSnackbar = false;
  successSnackbarText = "";

  showingErrorSnackbar = false;
  errorSnackbarText = "";

  snackbarTimeout = 5000; 

  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  get isAllowedToDefineOwnDeviceCategoriesAndTemplates() {
    return defineCategoriesAndTemplatesClientAccess();
  }

  get sharedDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.sharedDeviceCategoriesAndTemplates;
  }

  get localDeviceSettingsJson() {
    return DeviceCategoriesAndTemplatesModule.localDeviceCategoriesAndTemplates;
  }

  get clientPanels() {
    return this.retrievedClientPanels;
  }

  get clientPanelsToDisplay() {
    return this.toClientPanels(this.sliceDevicesToDisplay(this.sliceLength));
  }

  get selectedDeviceCategory() {
    const selectedDeviceCategories = DevicesModule.selectedCategories;

    if (selectedDeviceCategories.length === 1) {
      return selectedDeviceCategories[0];
    }

    return null;
  }

  get deviceFilterIconRes() {
    return "mdi-filter-variant";
  }
  
  get deviceOverviews() {
    return this.retrieveDeviceOverviews;
  }

  get noDevicesHintMessage() {
    if (this.searchQuery) {
      return this.$t("allDevices.noMatchingDevicesFound").toString();
    }
    else if (this.isIresDeviceTemplate(this.templateId)) {
      return this.$t("allDevices.emptyPanelTypes", [this.selectedTemplateName]).toString();
    }
    else {
      return this.$t("allDevices.emptyDevicesHint").toString();
    }
  }

  /**
   * Iterates over each device overview, updating the category and template IDs based on shared device settings.
   * This method leverages the `getUpdatedCategoryAndTemplateIds` function to find the updated category and template IDs
   * from the shared device settings that correspond to the local settings for each device. It then updates these IDs
   * in the device overview list.
   *
   * @returns {DeviceOverview[]} An array of device overview objects with updated category and template IDs.
   */
  get deviceOverviewsWithUpdatedCategoryAndTemplateIds() {
    const deviceOverviews = this.deviceOverviews;

    deviceOverviews.forEach((device) => {
      const { updatedCategoryId, updatedTemplateId } = getUpdatedCategoryAndTemplateIds(
        device.categoryId,
        device.templateId,
        this.localDeviceSettingsJson,
        this.sharedDeviceSettingsJson,
        device.devicePowerUsageType ?? undefined,
      );

      device.categoryId = updatedCategoryId;
      device.templateId = updatedTemplateId;
    });

    return deviceOverviews;
  }

  get deviceOverviewsToDisplay() {
    return this.toOtherDevices(this.sliceDevicesToDisplay(this.sliceLength));
  }

  get devicesToDisplay() {
    const deviceOverviews = this.deviceOverviewsWithUpdatedCategoryAndTemplateIds;

    return deviceOverviews.filter((deviceOverview) => deviceOverview.templateId === this.templateId)
  }

  get isAllowedToEditDevices() {
    const user = getReactiveActiveUser();

    if (!user) {
      return false;
    }

    return editAllDevicesAccess(user);
  }

  get isDefaultBranchFilterSelected() {
    return this.selectedBranchFilter.isDefaultBranchFilter();
  }

  get panelsToDisplay() {
    return this.clientPanels.filter((panel) => {
      return getTemplateIdFromSerialNumber(panel.serialNumber) === this.templateId;
    });
  }

  get selectedTemplate() {
    return DevicesModule.selectedTemplates;
  }

  get showInfiniteLoading() {
    return isIresTemplate(this.templateId) 
      ? this.panelsToDisplay.length > 0
      : this.devicesToDisplay.length > 0;
  }

  get areSelectionActionsEnabled() {
    return this.selectedClientPanels.length > 0 || this.selectedDeviceOverviews.length > 0;
  }

  get isEditingAllowedForSelection() {
    return this.areSelectionActionsEnabled;
  }

  get isDeletionAllowedForSelection() {
    const isClientPanelAssignedToProject = this.selectedClientPanels.find((clientPanel) => clientPanel.currentProjectId !== null);
    const isOtherDeviceAssignedToProject = this.selectedDeviceOverviews.find((device) => device.currentlyAssigned);

    return this.areSelectionActionsEnabled && !isClientPanelAssignedToProject && !isOtherDeviceAssignedToProject;
  }

  get showSwitchSelectionModeIcon() {
    return this.isSelectionMode || 
      (
        !this.showNoDevicesMessage &&
        (
          this.clientPanelsToDisplay.length > 0 ||
          this.deviceOverviewsToDisplay.length > 0
        )
      );
  }

  get numberOfDevices() {
    return this.noOfFilteredDevices;
  }

  get numberOfDevicesSelected() {
    return this.selectedDeviceOverviews.length + this.selectedClientPanels.length;
  }

  get selectedDeviceFiltersDescription() {
    const numberOfDevices = this.numberOfDevices;
    const numberOfDevicesSelected = this.numberOfDevicesSelected;

    let filtersName = this.isSelectionMode
      ? this.$tc("allDevices.descriptionAlt", numberOfDevicesSelected).toString()
      : this.$tc("allDevices.description", numberOfDevices).toString();
    let isFilterEnabled = false;

    // Might use later
    /* const selectedClientFilterName = this.selectedClientFilter.client
      ? getClientName(this.selectedClientFilter.client)
      : this.$t("common.all");

    if (this.isAllowedToViewClientSelector && selectedClientFilterName !== this.$t("common.all")) {
      filtersName += " (" + selectedClientFilterName;
      isFilterEnabled = true;
    } */

    const selectedBranchFilterName = this.selectedBranchFilter.branch
      ? getBranchName(this.selectedBranchFilter.branch)
      : this.$t("common.all");

    if (selectedBranchFilterName !== this.$t("common.all")) {
      filtersName += !isFilterEnabled
        ? " ("
        : "";
      filtersName += /* (this.isAllowedToViewClientSelector
        ? ": "
        : "") +  */selectedBranchFilterName;
      isFilterEnabled = true;
    }

    return filtersName + (isFilterEnabled ? ")" : "");
  }

  get shouldHideSerialNumber() {
    return shouldHideSerialNumber();
  }
  
  @Watch("hasNoDevices")
  onHasNoDevicesChanged(value: boolean) {
    if (value) {
      this.isLoading = true;
      this.timer = setTimeout(() => {
        this.isLoading = false;
        this.showNoDevicesMessage = true;
      }, 1000);
    } else {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.isLoading = false;
      this.showNoDevicesMessage = false;
    }
  }

  @Watch("selectedBranchFilter")
  onBranchFilterChanged() {
    this.resetDevices();
    this.storeBranch();
  }

  @Watch("selectedDeviceFilter")
  onFilterChanged(newFilter: GenericDeviceFilter) {
    this.setToolbarTitle(newFilter);
    this.resetDevices();

    setNumber(this.storageKeyAllDevicesFilter, this.selectedDeviceFilter);
  }

  calculateBackgroundStyle(itemId: string) {
    return calculateBackgroundStyle(itemId, StorageKeyLastVisitedItemLevel.LEVEL_3);
  }

  showSuccessSnackbar(message: string) {
    this.showingSuccessSnackbar = true;
    this.successSnackbarText = message;
  }

  showErrorSnackbar(message: string) {
    this.showingErrorSnackbar = true;
    this.errorSnackbarText = message;
  }

  toggleSelectionMode() {
    this.selectedClientPanels = [];
    this.selectedDeviceOverviews = [];

    setLastVisitedItem(
      null,
      StorageKeyLastVisitedItemLevel.LEVEL_3
    );

    this.isSelectionMode = !this.isSelectionMode;
  }

  async editSelectedDevices() {
    if (this.isSelectionMode) {
      this.deviceDetailsDialog.show();
    }
  }

  async deleteSelectedDevices() {
    const result = await this.confirmationDialog.show({
      title: this.$t("allDevices.deletionConfirmationDialog.title").toString(),
      message: this.$t("allDevices.deletionConfirmationDialog.message").toString(),
      acceptMessage: this.$t("common.delete").toString(),
    });

    if (result) {
      this.isDeletingDevices = true;
      const deletedClientPanelsInventoryNumbers = (
        await getUpdatedIdsAfterDeletion(
          this.selectedClientPanels.map(clientPanel => clientPanel.inventoryNumber ?? ""),
          "inventoryNumber",
          getClientPanelsRef()
        )
      );

      const deletedDeviceOverviewsInventoryNumbers = (
        await getUpdatedIdsAfterDeletion(
          this.selectedDeviceOverviews.map(deviceOverview => deviceOverview.inventoryNumber ?? ""),
          "inventoryNumber",
          getClientDevicesRef()
        )
      );

      // Each QR code is released alongside its inventory number, so the label can go on another device.
      const releasedClientPanelQrCodes = await getReleasedQrCodes(
        new Map<string, string | null | undefined>(
          this.selectedClientPanels.map(clientPanel => [clientPanel.serialNumber, clientPanel.qrCode])
        ),
        getClientPanelsRef()
      );

      const releasedDeviceQrCodes = await getReleasedQrCodes(
        new Map<string, string | null | undefined>(
          this.selectedDeviceOverviews.map(deviceOverview => [deviceOverview.id, deviceOverview.qrCode])
        ),
        getClientDevicesRef()
      );

      if (
        deletedClientPanelsInventoryNumbers.size === this.selectedClientPanels.length &&
        deletedDeviceOverviewsInventoryNumbers.size === this.selectedDeviceOverviews.length &&
        releasedClientPanelQrCodes &&
        releasedDeviceQrCodes
      ) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedClientPanels = new Map<string, any>();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedOtherDevices = new Map<string, any>();

        const devicesToBeRemovedFromVehicles = new Map<string, string[]>();

        deletedClientPanelsInventoryNumbers.forEach((updatedInventoryNumber, originalInventoryNumber) => {
          const clientPanel = this.selectedClientPanels.find(
            (clientPanel) =>
              (
                (
                  !clientPanel.inventoryNumber &&
                  updatedInventoryNumber[0] === DELETION_SEPARATOR
                ) ||
                clientPanel.inventoryNumber === originalInventoryNumber
              ) && 
              !updatedClientPanels.has(clientPanel.serialNumber)
          );

          if (clientPanel) {
            const vehicleId = clientPanel.vehicleId;
            if (vehicleId) {
              const existingDeviceList = devicesToBeRemovedFromVehicles.get(vehicleId);

              if (existingDeviceList) {
                existingDeviceList.push(clientPanel.serialNumber);
              } else {
                devicesToBeRemovedFromVehicles.set(vehicleId, [clientPanel.serialNumber]);
              }
            }

            updatedClientPanels.set(
              clientPanel.serialNumber,
              {
                inventoryNumber: updatedInventoryNumber,
                availability: -1,
                vehicleId: null,
                ...(releasedClientPanelQrCodes.has(clientPanel.serialNumber)
                  ? { qrCode: releasedClientPanelQrCodes.get(clientPanel.serialNumber) }
                  : {})
              }
            )
          }
        });

        deletedDeviceOverviewsInventoryNumbers.forEach((updatedInventoryNumber, originalInventoryNumber) => {
          const deviceOverview = this.deviceOverviews.find(
            (deviceOverview) =>
              (
                (
                  !deviceOverview.inventoryNumber &&
                  updatedInventoryNumber[0] === DELETION_SEPARATOR
                ) ||
                deviceOverview.inventoryNumber === originalInventoryNumber
              ) && 
              !updatedOtherDevices.has(deviceOverview.id)
          );

          if (deviceOverview) {
            const vehicleId = deviceOverview.vehicleId;
            if (vehicleId) {
              const existingDeviceList = devicesToBeRemovedFromVehicles.get(vehicleId);

              if (existingDeviceList) {
                existingDeviceList.push(deviceOverview.id);
              } else {
                devicesToBeRemovedFromVehicles.set(vehicleId, [deviceOverview.id]);
              }
            }

            updatedOtherDevices.set(
              deviceOverview.id,
              {
                inventoryNumber: updatedInventoryNumber,
                availability: -1,
                vehicleId: null,
                ...(releasedDeviceQrCodes.has(deviceOverview.id)
                  ? { qrCode: releasedDeviceQrCodes.get(deviceOverview.id) }
                  : {})
              }
            )
          }
        });

        const [isUpdateClientPanelsSuccessful, isUpdateOtherDevicesSuccessful] = await Promise.all([
          updateClientPanelsBySerialNumber(updatedClientPanels),
          updateDevicesById(updatedOtherDevices),
          removeDevicesFromVehicleMapBatch(devicesToBeRemovedFromVehicles)
        ]);

        if (isUpdateClientPanelsSuccessful) {
          this.selectedClientPanels = [];
        }

        if (isUpdateOtherDevicesSuccessful) {
          this.selectedDeviceOverviews = [];
        }
      
        if (isUpdateClientPanelsSuccessful && isUpdateOtherDevicesSuccessful) {
          this.isSelectionMode = false;
          this.showSuccessSnackbar("allDevices.deletionConfirmationDialog.successMessage");
        }
        else {
          this.showErrorSnackbar("allDevices.deletionConfirmationDialog.errorMessage");
        }
      }
      else {
        this.showErrorSnackbar("allDevices.deletionConfirmationDialog.errorMessage");
      }

      this.isDeletingDevices = false;
    }
  }

  getEditIconColor() {
    return this.isEditingAllowedForSelection
      ? COLOR_HEADER_BUTTON
      : COLOR_DISABLED;
  }

  getDeleteIconColor() {
    return this.isDeletionAllowedForSelection
      ? COLOR_HEADER_BUTTON
      : COLOR_DISABLED;
  }

  getVehicle(device: DeviceOverview | ClientPanel) {
    if (!device.vehicleId) {
      null;
    }

    const vehicle = this.vehicles.find((v) => v.id === device.vehicleId);

    return vehicle ?? null;
  }

  isClientPanelSelected(clientPanel: ClientPanel) {
    return this.selectedClientPanels.includes(clientPanel);
  }

  isOtherDeviceSelected(device: DeviceOverview) {
    return this.selectedDeviceOverviews.includes(device);
  }
  
  clearSearchQuery() {
    this.searchQuery = null;
    this.resetDevices();
  }

  async infiniteHandler(data: StateChanger) {
    const nextSliceLength = this.sliceLength + this.pageSize;
    const nextSlice = this.sliceDevicesToDisplay(nextSliceLength);

    this.sliceLength = nextSliceLength;

    if (nextSliceLength > nextSlice.length) {
      data.complete();
    } else {
      data.loaded();
    }
  }

  debounceSearch(newQuery: string) {
    if (this.searchTimeout) {
      clearTimeout(this.searchTimeout);
    }

    if (newQuery === "") {
      this.clearSearchQuery();
      return;
    }

    this.searchTimeout = setTimeout(() => {
      this.processSearchQuery(newQuery);
    }, 400);
  }

  filterDevices(devices: (DeviceOverview | ClientPanel)[]) {
    const filter = this.selectedDeviceFilter;
    const branchFilter = this.selectedBranchFilter;
    const searchQuery = this.searchQuery?.toUpperCase();
    const isDefaultBranchFilterSelected = this.isDefaultBranchFilterSelected;

    const result = devices.filter((device: DeviceOverview | ClientPanel) =>
        (
          branchFilter.doesMatchGenericDevice(device) ||
          isDefaultBranchFilterSelected
        ) &&
        matchesGenericDeviceFilter(
          filter,
          device
        )
      )

    if (searchQuery) {
      const searchQueryLowerCase = searchQuery.toLowerCase();

      const searchedDevices = result.filter(
        (device: DeviceOverview | ClientPanel) => {
          if (isClientPanel(device)) {
            const panel = device as ClientPanel;

            return (
                panel.serialNumber
                  .toLowerCase()
                  .includes(searchQueryLowerCase) &&
                !this.shouldHideSerialNumber
              ) ||
              panel.inventoryNumber
                ?.toLowerCase()
                .includes(searchQueryLowerCase)
          }
          else {
            const deviceOverview = device as DeviceOverview;

            return deviceOverview.serialNumber
                ?.toLowerCase()
                .includes(searchQueryLowerCase) ||
              deviceOverview.qrCode
                ?.toLowerCase()
                .includes(searchQueryLowerCase) ||
              deviceOverview.inventoryNumber
                ?.toLowerCase()
                .includes(searchQueryLowerCase)
          }
        });

        if (this.hasNoDevices !== false) {
          this.hasNoDevices = searchedDevices.length === 0;
        }

        return this.isSelectionMode ? sortDevices(filterRetainedDevices(searchedDevices)) : sortDevices(searchedDevices);
    }

    const retainedDevices = filterRetainedDevices(result);

    if (this.hasNoDevices !== false) {
      this.hasNoDevices = retainedDevices.length === 0;
    }

    return sortDevices(retainedDevices);
  }

  getAllFiltersName() {
    let filtersName = this.getGenericFilterName(this.selectedDeviceFilter);

    const selectedBranchFilterName = this.selectedBranchFilter.branch
      ? getBranchName(this.selectedBranchFilter.branch)
      : this.$t("common.all");

    if (selectedBranchFilterName !== this.$t("common.all")) {
      filtersName += ", " + selectedBranchFilterName;
    }

    return filtersName;
  }

  getGenericFilterName(deviceFilter: GenericDeviceFilter) {
    return getGenericFilterName(this, deviceFilter);
  }

  isIresDeviceTemplate(templateId: string) {
    return isIresTemplate(templateId);
  }

  onCreateDevice() {
    const title = this.$t("allDevices.createDeviceDialogTitle", [this.selectedTemplateName]).toString();

    this.createDeviceDialog.show(title, null, [], undefined, true);
  }

  onOpenDeviceDetails(device: DeviceOverview | ClientPanel, isClientPanel: boolean) {
    if (!this.isSelectionMode) {
      const index = isClientPanel
        ? this.clientPanelsToDisplay.indexOf(device as ClientPanel)
        : this.deviceOverviewsToDisplay.indexOf(device as DeviceOverview);

      setNumber(
        this.storageKeySliceLength,
        this.pageSize + Math.floor(index / this.pageSize) * this.pageSize
      );

      this.forceUpdateBackgroundColor = !this.forceUpdateBackgroundColor;
    }
    else {
      if (isClientPanel) {
        const clientPanel = device as ClientPanel;
        const index = this.selectedClientPanels.indexOf(clientPanel, 0);
        
        if (index > -1) {
          this.selectedClientPanels.splice(index, 1);
        }
        else {
          this.selectedClientPanels.push(clientPanel);
        }
      }
      else {
        const deviceOverview = device as DeviceOverview;
        const index = this.selectedDeviceOverviews.indexOf(deviceOverview, 0);
        
        if (index > -1) {
          this.selectedDeviceOverviews.splice(index, 1);
        }
        else {
          this.selectedDeviceOverviews.push(deviceOverview);
        }
      }
    }
  }

  processSearchQuery(newQuery: string) {
    this.searchQuery = newQuery;
    this.resetDevices();
  }

  resetDevices() {
    this.hasNoDevices = true;
    this.showNoDevicesMessage = false;
    this.isLoading = true;
    this.sliceLength = this.pageSize;
    this.infiniteId = new Date();
  }

  storeBranch() {
    if (this.selectedBranchFilter.branch?.id) {
      setStoredBranchFilterId(this.storageKeyBranchFilter, this.selectedBranchFilter.branch.id);
    }
    else {
      removeStoredBranchFilterId(this.storageKeyBranchFilter);
    }
  }

  get selectedTemplateName() {
    return this.selectedTemplate && this.selectedTemplate.length !== 0
      ? this.selectedTemplate[0].deviceName
      : "";
  }

  setToolbarTitle(newFilter: GenericDeviceFilter) {
    const toolbarTitle = 
      this.$t("pages.allDevices").toString() + 
      " > " + 
      this.selectedCategoryName + 
      " > " + 
      this.selectedTemplateName
    ;

    const devicesString = this.selectedDeviceFilter === GenericDeviceFilter.ALL_DEVICES
      ? `${toolbarTitle}`
      : `${toolbarTitle} (${this.getGenericFilterName(newFilter)})`

    ToolbarContentModule.setToolbarTitle(devicesString);
  }

  sliceDevicesToDisplay(length: number) {
    const devicesToDisplay = isIresTemplate(this.templateId)
      ? this.filterDevices(this.panelsToDisplay)
      : this.filterDevices(this.devicesToDisplay);

    this.noOfFilteredDevices = devicesToDisplay.length;

    return devicesToDisplay.slice(0, length);
  }

  startRefreshTimer() {
    this.refreshTimer = setInterval(() => {
      this.refreshTrigger++;
    }, 60 * 1000);
  }

  toClientPanels(devices: (DeviceOverview | ClientPanel)[]) {
    return devices as ClientPanel[];
  }

  toOtherDevices(devices: (DeviceOverview | ClientPanel)[]) {
    return devices as DeviceOverview[];
  }

  activated() {
    this.componentActive = true;
    this.setToolbarTitle(this.selectedDeviceFilter);
  }

  beforeDestroy() {
    this.subscriptions.forEach((subscription) => subscription());
    clearInterval(this.refreshTimer);
  }

  async created() {
    this.categoryId = router.currentRoute.params["categoryId"];
    this.templateId = router.currentRoute.params["templateId"];

    this.selectedCategoryName = router.currentRoute.query["selectedCategoryName"] as string;

    const vehicles = await getAllVehiclesOfClient();
    this.vehicles = vehicles;

    const cachedDeviceFilter =
      getNumber(this.storageKeyAllDevicesFilter) ?? GenericDeviceFilter.ALL_DEVICES;

    if (cachedDeviceFilter != null && cachedDeviceFilter !== undefined) {
      this.selectedDeviceFilter = cachedDeviceFilter;
    }

    const cachedSliceLenth = getNumber(this.storageKeySliceLength);
    if (cachedSliceLenth) {
      this.sliceLength = cachedSliceLenth;
      setNumber(this.storageKeySliceLength);
    }

    setTimeout(() => {
      if (this.hasNoDevices) {
        this.isLoading = false;
        this.showNoDevicesMessage = true;
      }
    }, 800);

    this.setToolbarTitle(this.selectedDeviceFilter);
  }

  deactivated() {
    this.componentActive = false;
  }

  mounted() {
    const branchIdQuery = getStoredBranchFilterId(this.storageKeyBranchFilter);

    if (branchIdQuery) {
      const matchingBranch = findBranch(branchIdQuery);

      if (matchingBranch) {
        this.selectedBranchFilter = new BranchFilter(
          hasClientEnabledStrictBranchFilters(),
          matchingBranch
        );
      }
    }

    const cachedSearchedQuery = localStorage.getItem(this.searchQueryKey);

    if (cachedSearchedQuery) {
      localStorage.removeItem(this.searchQueryKey);
      
      this.searchQuery = cachedSearchedQuery;
    }

    this.subscriptions.push(observeDeviceOverviews(
      (deviceOverview: Array<DeviceOverview>) => {
        this.retrieveDeviceOverviews = deviceOverview;
      }
    ));
    this.subscriptions.push(observeClientPanels(
      (clientPanels: Array<ClientPanel>) => {
        this.retrievedClientPanels = clientPanels;
      }
    ));

    this.startRefreshTimer();

    this.componentActive = true;
  }
}
